import { APIKit } from 'config/axios';
import { end, error, start } from 'config/redux/slice';
import store from 'config/redux/index';
import { AppConstants, ServerConstants, ServiceConstants } from '../constants';
import { ServiceModel } from 'models';
import { LoginData, LoginResponse } from 'types';
import { CryptoUtils, StorageUtils } from 'utils';

const {
  STORAGE_ACCESS_TOKEN,
  STORAGE_VALID_TO,
} = AppConstants;

const {
  API_V1_WEB,
  API_V1_AUTH_LOGIN_RENEW,
  API_V1_WEB_LOGIN,
} = ServerConstants;

const {
  REQUEST_LOGIN_ID,
  REQUEST_RENEW_ID,
  REQUEST_RECOMMENDATIONS_ID,
  REQUEST_CONTACT_ID,
} = ServiceConstants;

export async function login(data: LoginData) {
  const requestId = REQUEST_LOGIN_ID;
  try {
    store.dispatch(start(requestId));
    const loginResponse = await APIKit.post(API_V1_WEB_LOGIN, data);
    const loginData: LoginResponse = loginResponse.data;
    StorageUtils.setObject(STORAGE_ACCESS_TOKEN, loginData.accessToken);
    StorageUtils.setObject(STORAGE_VALID_TO, loginData.validTo);
    store.dispatch(end(new ServiceModel(requestId)));
  } catch (err: any) {
    store.dispatch(error(new ServiceModel(requestId, err)));
  }
}

export async function renew() {
  const requestId = REQUEST_RENEW_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_AUTH_LOGIN_RENEW);
    const data: LoginResponse = response.data;
    StorageUtils.setObject(STORAGE_ACCESS_TOKEN, data.accessToken);
    StorageUtils.setObject(STORAGE_VALID_TO, data.validTo);
    initApp();
    store.dispatch(end(new ServiceModel(requestId)));
    return true;
  } catch (err: any) {
    store.dispatch(error(new ServiceModel(requestId, err)));
    return false;
  }
}

export function initApp() {
  // AppUtils.changeLanguage('de');
}

export async function submitRecommendations(data: any) {
  const requestId = REQUEST_RECOMMENDATIONS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_WEB}/user-recommendation`, { ...data });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    store.dispatch(error(new ServiceModel(requestId, err)));
  }
}

export async function sendEmail(values: any) {
  const requestId = REQUEST_CONTACT_ID;
  try {
    store.dispatch(start(requestId));
    const data = {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      email: values.email.trim(),
      phone: values.phoneNumber.trim(),
      message: values.message.trim()
    }
    console.log(data);
    console.log(CryptoUtils.encrypt(data));
    await APIKit.post(`${API_V1_WEB}/email-contact`, data);
    store.dispatch(end(new ServiceModel(requestId)));
  } catch (err: any) {
    store.dispatch(error(new ServiceModel(requestId, err)));
  }
}

